<script lang="ts">
	import type { Snippet } from 'svelte';

	interface Props {
		active?: boolean;
		onclick?: () => void;
		class?: string;
		children?: Snippet;
		image?: Snippet;
	}

	let { active = false, onclick, class: className, children, image }: Props = $props();
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<!-- svelte-ignore a11y_click_events_have_key_events -->
<div
	class={[
		'mx-[110px] flex-none basis-[100%] transition-opacity lg:basis-[40%] 2xl:basis-[19%]',
		className,
		{
			'cursor-pointer opacity-[27%]': !active
		}
	]}
	{onclick}
>
	<div class="flex select-none flex-col items-center">
		{#if image}
			<div class="h-6 lg:h-7">
				{@render image()}
			</div>
		{/if}
		{#if children}
			<p class="mt-5 text-center text-[16px]/[140%]">
				{@render children()}
			</p>
		{/if}
	</div>
</div>
